const aboutData = [
    {
        year: '2017-2021',
        dept: 'Information Technology',
        College: 'KKWIEER,Nashik',
        description: 'Bachelor of Engineering in Information Technology from SPPU University',
        Scored: ': 8.66 CGPA'
    },
    {
        year: '2017',
        dept: 'Higher Secondary Certificate (HSC)',
        school: "RYK College,Nashik",
        description: 'Subjects: Physics, Chemistry, Mathematics, Biology',
        Scored: '83.69%'
    },
    {
        year: '2015',
        dept: 'Senior Secondary Certificate (SSC)',
        school: "LVH Vidyalaya,Nashik",
        description: 'Maharashtra State Board',
        Scored: '92.60%'
    }
];
export default aboutData;
